export const filters = [{ name: 'page', type: 'string', defaultValue: 1 }]

export const filterNames = {
  page: 'page',
}
